import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

// Routes
// import hhRoutes from './hackyholidays_io_routes';

Vue.use(VueRouter);

const defaultRoutes: Array<RouteConfig> = [
  {
    path: '/:country([a-z][a-z])?',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/Home.vue')
  },
];

function getRoutes(): Array<RouteConfig> {
  // const host = window.location.host;
  // const parts = host.split('.');
  // const domainLength = 3; // route1.example.com => domain length = 3
  // let routes = defaultRoutes;

  // if (host.startsWith('hackyholidays.')) {
  //   routes = hhRoutes;
  // } else if (host.startsWith('join.hackyholidays.')) {
  //   routes = joinRoutes;
  // } else if (host.startsWith('deloitte.hackyholidays.')) {
  //   routes = deloitteRoutes;
  // } else {
  //   routes = defaultRoutes;
  // }

  return defaultRoutes;
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: getRoutes(),
});

export default router;
